const NO_VIEWED = "global_css_no_viewed";
const FINISHED = "global_css_finished";
const NOT_ENOUGH = "global_css_not_enough";
const ERROR_PLACEHOLDER = "global_css_error_placeholder";


export const RowClassName = ({ data }) => {
  // if (data?.status === "Проведен" && data?.type === "Заявка на производство") {
  //   if (data?.viewStatus?.status === "Не просмотрено") return NO_VIEWED + " " + FINISHED;
  //   return FINISHED;
  // }
  if (data?.isArchive) {
    if (data?.viewStatus?.status === "Не просмотрено") return NO_VIEWED + " " + FINISHED;
    return FINISHED;
  }
  if (data?.viewStatus?.status === "Не просмотрено") {
    return NO_VIEWED;
  }
  // if (data?.viewStatus?.status === "Просмотрено") {
  //   if (data?.inStockBalanceStatus === "Не хватает" || data?.status === "Не обеспечена") return NOT_ENOUGH;
  //   return ""
  // }
  // if (data?.viewStatus === null) {
  //   if (data?.inStockBalanceStatus === "Не хватает" || data?.status === "Не обеспечена") return NOT_ENOUGH;
  //   return ""
  // }
  return ""
}

export const ItemsRowClassName = ({ data }) => {
  if (data?.hasError === true) {
    return NO_VIEWED
  }
  return ""
}
